import { Fulfillment } from "@secondcloset/types";
import { getAPIFromDomain } from "../../lib/api";
import UrlBuilder from "../../lib/UrlBuilder";

export interface FetchCarrierQuery {
  organization_id?: string;
  per_page?: number;
  include_defaults?: boolean;
}
export const fetchCarriers = async (query: FetchCarrierQuery): Promise<Fulfillment.Carrier[]> => {
  const baseUrl = "/carriers";
  const api = getAPIFromDomain("logistics");
  const url = new UrlBuilder(baseUrl).applyQueryStringFromObject(query);

  const response = await api.get(url);
  return response.data.carriers;
};
